import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../config';
import {
    updateBoosterStatus,
    setBoosterPopupState,
} from './../actions/FormationActions';
import common from "../common";

class BoosterPopUp extends Component {

    closePopup = () => {
        this.props.setBoosterPopupState({ showBoosterPopup: false });
    };

    confirmPopup = (type) => {
        if (type === config.booster["limitless"]) {
            common.customTracking('Booster Confirm - Limitless', '/uclfantasy/my-team/transfers/');
            this.props.updateBoosterStatus('IsBoosterOneTaken', '-1');
        } else if (type === config.booster["wildcard"]) {
            common.customTracking('Booster Confirm - Wildcard', '/uclfantasy/my-team/transfers/');
            this.props.updateBoosterStatus('IsWildCardTaken', '-1');
        }
        this.closePopup();
    }

    getTrans(key, transKey, backup) {
        // get current MDID
        let mdayId = this.props.userSpecificFixtures[0]['GDID'] ? this.props.userSpecificFixtures[0]['GDID'] : "";
        let trans = this.props.trans;
        let scriptedTrans = trans[key + transKey] ? trans[key + transKey] : backup;
        return scriptedTrans.replace("{{1}}", mdayId);

    }

    render() {
        const { trans } = this.props;
        const { type } = this.props.boosterPopupState;
        let mdayId = this.props.userSpecificFixtures[0]['GDID'] ? this.props.userSpecificFixtures[0]['GDID'] : "";
        let body = null;
        switch (type) {
            case '1': {
                let key = "wildcard";
                body = <div className="si-common-popup si-transfer-popup">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-wildcard"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-title">{ this.getTrans(key, 'Title', 'Activate your Limitless Wildcard') }</div>
                            <div className="si-more-info"><span>{ this.getTrans(key, 'Body', 'Get unlimited transfers for 1 matchday per season, so use it wisely! All changes you make with the Wildcard will be permanent.') }</span></div>
                            <div className="si-details-desc">
                                <i className="icon-ucl-warning-icon"></i>
                                <span>{ this.getTrans(key, 'Warning', "Wildcard can't be deactivated") }</span>
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-secondary-wb" onClick={ () => this.closePopup() }>
                            <span>{ this.getTrans(key, 'CTAnegative', 'Save for later  ') }</span>
                        </div>
                        <div className="si-btn si-btn-primary" onClick={ () => this.confirmPopup(type) }>
                            <span>{ this.getTrans(key, 'CTApositive', ('Activate ' + key)) }</span>
                        </div>
                    </div>

                </div>
                break;
            }
            case '2': {
                let key = "limitless";
                body = <div className="si-common-popup si-transfer-popup">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-limitless"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-title">{ this.getTrans("limitless", 'Title', 'Activate your Limitless Wildcard') }</div>
                            <div className="si-more-info"><span>{ this.getTrans(key, 'Body', 'Get unlimited transfers with an unlimited budget for 1 matchday per season - so use it wisely! Once the matchday is over, the team you had before playing the Limitless Wildcard will be reinstated.Once activated, you have to use it on that matchday.') }</span></div>
                            <div className="si-details-desc">
                                <i className="icon-ucl-warning-icon"></i>
                                <span>{ this.getTrans(key, 'Warning', "Limitless can't be deactivated") }</span>
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-secondary-wb" onClick={ () => this.closePopup() }>
                            <span>{ this.getTrans(key, 'CTAnegative', 'Save for later  ') }</span>
                        </div>
                        <div className="si-btn si-btn-primary" onClick={ () => this.confirmPopup(type) }>
                            <span>{ this.getTrans(key, 'CTApositive', ('Activate ' + key)) }</span>
                        </div>
                    </div>

                </div>
                break;
            }
            case '3': {
                let key = this.props.case + "BeforeMatchDay";
                body = <div className="si-common-popup si-transfer-popup">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-wildcard"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-title">{ this.getTrans("wildcard", 'Title', 'will be active after matchday ' + " " + mdayId) }</div>
                            <div className="si-more-info"><span>{ this.getTrans(key, 'Body', 'will be active after matchday ' + " " + mdayId) }</span></div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-secondary-wb" onClick={ () => this.closePopup() }>
                            <span>{ this.getTrans(key, 'CTAnegative', 'Ok got it') }</span>
                        </div>
                        {/* <div className="si-btn si-btn-primary" onClick={ () => this.confirmPopup(type) }>
                            <span>{ this.getTrans(key, 'CTApositive', ('Activate ' + key)) }</span>
                        </div> */}
                    </div>

                </div>
                break;
            }
            case '4': {
                let key = this.props.case + "BeforeMatchDay";
                body = <div className="si-common-popup si-transfer-popup">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-limitless"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-title">{ this.getTrans("limitless", 'Title', 'will be active after matchday' + " " + mdayId) }</div>
                            <div className="si-more-info"><span>{ this.getTrans(key, 'Body', 'will be active after matchday' + " " + mdayId) }</span></div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-secondary-wb" onClick={ () => this.closePopup() }>
                            <span>{ this.getTrans(key, 'CTAnegative', 'Ok got it') }</span>
                        </div>
                        {/* <div className="si-btn si-btn-primary" onClick={ () => this.confirmPopup(type) }>
                            <span>{ this.getTrans(key, 'CTApositive', ('Activate ' + key)) }</span>
                        </div> */}
                    </div>

                </div>
                break;
            }
            default: {
                body = null;
            }
        }
        return <div id={ "boosterModal" }>
            { body ? <div className="si-modal-wrap" onClick={ () => this.closePopup() } > { body }</div> : null }
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateBoosterStatus: (key, value) => dispatch(updateBoosterStatus(key, value)),
        setBoosterPopupState: (obj) => dispatch(setBoosterPopupState(obj)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        boosterPopupState: state.formationData.boosterPopupState,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BoosterPopUp);


// WEBPACK FOOTER //
// ./src/components/BoosterPopup.js